import {Component, OnInit} from "@angular/core";
import {AccountInformationFormFactory} from "../../core/forms/account-information/account-information-form.factory";
import {ValidationHelperService} from "../../../../../core/helpers/validation-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AccountControllerService} from "../../../../../core/api/controllers/account-controller/account-controller.service";
import {
  IGetAccountInformationResponse
} from "../../../../../core/api/controllers/account-controller/interfaces/get-account-information.response";
import {SettingsService} from "../../../../../core/services/settings.service";
import {MatDialogRef} from "@angular/material/dialog";
import {
  IChangeAccountInformationRequest,
  ICityPayload
} from "../../../../../core/api/controllers/account-controller/interfaces/change-account-information.request";
import {ICity} from "../../../../../core/models/geography.model";

@Component({
  selector: 'app-change-account-information-dialog',
  templateUrl: './change-account-information-dialog.component.html',
  styleUrls: ['./change-account-information-dialog.component.scss']
})
export class ChangeAccountInformationDialogComponent implements OnInit{
  _form = AccountInformationFormFactory.create();
  protected readonly ValidationHelperService = ValidationHelperService;

  isLoading = false;
  prefillInformation: IGetAccountInformationResponse;

  constructor(
      private accountController: AccountControllerService,
      private matSnackbar: MatSnackBar,
      public settingsService: SettingsService,
      private dialogRef: MatDialogRef<ChangeAccountInformationDialogComponent>
  ) {}

  ngOnInit(): void {
    this.getAccountInformation();
  }

  getAccountInformation(): void {
    this.isLoading = true;
    this.accountController.getAccountInformation().subscribe({
      next: (response) => {
        this.prefillInformation = response;
        this.prefillForm(response);
        this.isLoading = false;
      },
      error: () => {
        this.matSnackbar.open("There was an error retrieving the account information. Please close this popup and open it again.");
        this.isLoading = false;
      }
    })
  }

  onSubmit(): void {
    this.isLoading = true;
    this.accountController.changeAccountInformation(this.createPayload()).subscribe({
      next: (res) => {
        this.matSnackbar.open("Your account changes has been saved succesfully!", "Close", {
          duration: 3000
        });
        this.dialogRef.close();
        this.isLoading = false;
      },
      error: () => {
        this.matSnackbar.open("There was an error saving your account information", "Close", {
          duration: 3000
        });
        this.isLoading = false;
      }
    })
  }

  createPayload(): IChangeAccountInformationRequest {


    return {
      user: {
        firstName: this._form.controls.user.controls.firstName.value,
        lastName: this._form.controls.user.controls.lastName.value,
        phoneNumber: this._form.controls.user.controls.phoneNumber.value,
        email: this._form.controls.user.controls.email.value,
      },
      organization: {
        organizationName: this._form.controls.organization.controls.organizationName.value,
        organizationAddress: {
          ...this.createCityPayload(this._form.controls.organization.controls.organizationAddress.controls.city.value, this._form.controls.organization.controls.organizationAddress.controls.state.value.id),
          addressLine1: this._form.controls.organization.controls.organizationAddress.controls.addressLine1.value,
          addressLine2: this._form.controls.organization.controls.organizationAddress.controls.addressLine2.value,
          zipCode: this._form.controls.organization.controls.organizationAddress.controls.zipCode.value
        },
        shippingAddress: {
          ...this.createCityPayload(this._form.controls.organization.controls.shippingAddress.controls.city.value, this._form.controls.organization.controls.shippingAddress.controls.state.value.id),
          addressLine1: this._form.controls.organization.controls.shippingAddress.controls.addressLine1.value,
          addressLine2: this._form.controls.organization.controls.shippingAddress.controls.addressLine2.value,
          zipCode: this._form.controls.organization.controls.shippingAddress.controls.zipCode.value,
          firstName: this._form.controls.user.controls.firstName.value,
          lastName: this._form.controls.user.controls.lastName.value,
        },
        billingAddress: {
          ...this.createCityPayload(this._form.controls.organization.controls.billingAddress.controls.city.value, this._form.controls.organization.controls.billingAddress.controls.state.value.id),
          addressLine1: this._form.controls.organization.controls.billingAddress.controls.addressLine1.value,
          addressLine2: this._form.controls.organization.controls.billingAddress.controls.addressLine2.value,
          zipCode: this._form.controls.organization.controls.billingAddress.controls.zipCode.value,
          firstName: this._form.controls.user.controls.firstName.value,
          lastName: this._form.controls.user.controls.lastName.value,
        },
      }
    }
  }

  createCityPayload(cityValue: string | ICity, stateId: string): ICityPayload {
    if(typeof cityValue === 'string') {
      return {
        newCity: {
          stateId,
          name: cityValue
        }
      }
    } else {
      return {
        cityId: cityValue.id
      }
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  prefillForm(response: IGetAccountInformationResponse): void {
    AccountInformationFormFactory.patchValue(this._form, response);
  }
}
